export const startLoadingSpinner = (element, color) => {
  const template = color ? document.getElementById('spinner-template-white') : document.getElementById('spinner-template');
  const clone = template.content.cloneNode(true);
  // replace element with spinner
  replaceTextWithSpinner(element, clone);
};

export const finishLoadingSpinner = (element, replaceElement) => {
  // replace spinner with element text
  document.querySelectorAll('.js-loading-spinner').forEach((el) => {
    // if ((form && el.form === form) || (btn && el === btn)) {
    //   el.textContent = el.dataset.loadingFinished;
    // }
    // element.innerHTML = replaceElement;
    if (replaceElement) {
      element.innerHTML = replaceElement;
    } else {
      element.innerHTML = '';
    }
  });
};


export const finishLoading = (form, btn) => {
  // replace spinner with element text
  document.querySelectorAll('.js-loading-spinner').forEach((el) => {
    if ((form && el.form === form) || (btn && el === btn)) {
      el.textContent = el.dataset.loadingFinished;
    }
  });
};

export const startLoading = (form, btn, color) => {
  const template = color ? document.getElementById('spinner-template-white') : document.getElementById('spinner-template');
  const clone = template.content.cloneNode(true);
  // replace element with spinner
  if (form) {
    document.querySelectorAll('.js-loading-spinner').forEach((el) => {
      if (el.form !== form) {
        return;
      }
      replaceTextWithSpinner(el, clone);
    });
  } else if (btn) {
    replaceTextWithSpinner(btn, clone);
  }
};

const replaceTextWithSpinner = (el, clone) => {
  if (el.replaceChildren) {
    el.replaceChildren(clone);
    return;
  }
  el.innerHTML = '';
  el.append(clone);
};
